// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../variables.css\"","mobile-threshold-width":"610px","listA":"ArchivedIssueList_listA__2lz81","issueImage":"ArchivedIssueList_issueImage__-nKLN"};